import { default as Mui5FormLabel } from '@mui/material/FormLabel'

export const FormLabel = Mui5FormLabel
